import { render, staticRenderFns } from "./vipBotton.vue?vue&type=template&id=163b42f8&scoped=true&"
import script from "./vipBotton.vue?vue&type=script&lang=ts&"
export * from "./vipBotton.vue?vue&type=script&lang=ts&"
import style0 from "./vipBotton.vue?vue&type=style&index=0&id=163b42f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163b42f8",
  null
  
)

export default component.exports